import {TRANSFER_AUTH_TOKEN_MUTATION} from "@khan/auth-shared";
import {type GqlFetchFn} from "@khan/data-gql";
import {getLocaleStatus} from "@khan/i18n";
import {getTransferAuthUrl, parseUrl} from "@khan/urls";

export const getCleverUserNextUrl = async (
    gqlFetch: GqlFetchFn,
    nextUrl: string,
    firstUserDistrictKaLocale: string | null,
    userUDIs?: string[],
): Promise<string> => {
    if (userUDIs?.length) {
        const locale = firstUserDistrictKaLocale || "en";
        if (locale === "en") {
            return nextUrl;
        }
        // The locale is something other than the default (en)
        // so we need to get a transfer auth code before we redirect
        // to another subdomain
        // The user has landed from a different locale, so use the transferAuthToken.
        const result = await gqlFetch(TRANSFER_AUTH_TOKEN_MUTATION, {});
        const transferAuthToken = result.createTransferAuthToken?.token;
        if (!transferAuthToken) {
            // something went wrong getting a transfer token, so just return the nextUrl
            return nextUrl;
        }

        const transferAuthURL = getTransferAuthUrl(
            transferAuthToken,
            nextUrl,
            {},
            locale,
            getLocaleStatus(locale),
        );

        // Add rigin as backup in case the transfer auth is relative.
        const transferAuthUrl: URL = parseUrl(transferAuthURL);
        const includesContinue = transferAuthUrl.searchParams.has("continue");

        // If the transfer URL contains the `continue` query param, then we
        // replace the value by the one we passed as an argument.
        if (includesContinue) {
            transferAuthUrl.searchParams.set("continue", nextUrl);
        }

        // Override the continueUrl with the parsed transfer auth url.
        return transferAuthUrl.href;
    }

    return nextUrl;
};
